import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import TableWrap from "./style";
import {
  Card,
  Table,
  Row,
  Col,
  Alert,
  Spinner,
  Button,
  Modal,
} from "react-bootstrap";
import InfiniteScroll from "react-infinite-scroll-component";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import Copy from "copy-to-clipboard";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import { useMediaQuery } from "@mui/material";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import CopyIcon from "../../../assets/images/icons/copy.svg";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import BlockIcon from "@mui/icons-material/Block";
import trashIcon from "../../../assets/images/icons/bluedelete12.svg";
import { useFetch } from "../../../Hooks/useFetch";
import { key } from "../../../data/queryKeys";
import { api } from "../../../Services/api";
import greenIcon from "../../../assets/images/icons/green.png";
import redIcon from "../../../assets/images/red.png";
import yellowIcon from "../../../assets/images/icons/yellow.png";
import moment from "moment-timezone";
import {
  setShowAlert,
  setAllTrackings,
  setMyTrackings,
  setAllPriorityData,
} from "../../../redux/Tracking/actionCreator";
import { useDispatch } from "react-redux";
import { logDOM } from "@testing-library/react";
import { useSessionStorage } from "react-use";

const Tables = (props) => {
  const dispatch = useDispatch();
  // Track which task is being accepted
  const priorityList = useSelector((state) => state.Tracking.allPriorityData);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [acceptTaskIndex, setAcceptTaskIndex] = useState(null);
  // State for Accept Task Modal
  const [showAcceptModal, setShowAcceptModal] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);
  const [slaHours, setSlaHours] = useState("");
  const [actualDeadline, setActualDeadline] = useState("");
  const [trackingItemData, setTrackingItemData1] = useSessionStorage(
    "myTaskTrackingData",
    {},
  );
  const user = useSelector((state) => state.Auth.user);
  const filterDataLoading = props?.filterDataLoading || false;

  // Handler for Accept Task
  const handleAcceptTask = (item, index) => {
    setSelectedTask(item);
    setShowAcceptModal(true);
    setAcceptTaskIndex(index);
  };

  const authToken = useSelector((state) => state.Auth.authToken);
  // State for Decline Task Modal
  const [showDeclineModal, setShowDeclineModal] = useState(false);
  const [declineTaskIndex, setDeclineTaskIndex] = useState(null);
  const [declineTask, setDeclineTask] = useState(null);
  const [declineReason, setDeclineReason] = useState(""); // State for decline reason

  // Handler for Decline Task (open modal)
  const handleDeclineTask = (item, index) => {
    setDeclineTask(item);
    setDeclineTaskIndex(index);
    setShowDeclineModal(true);
  };

  const handleSlaChange = (e) => {
    const value = e.target.value;

    // Only allow digits (prevent e, +, -, .)
    if (/^\d*$/.test(value)) {
      setSlaHours(value);

      if (value.trim() !== "") {
        const deadline = moment().add(Number(value), "hours");
        setActualDeadline(deadline.format("MMM D, YYYY hh:mm A"));
      } else {
        setActualDeadline("");
      }
    }
  };

  // Confirm Decline Task (API call and update state)
  const confirmDeclineTask = async () => {
    if (!declineTask || declineTaskIndex === null) return;

    // Validate SLA and reason before proceeding
    if (!slaHours || isNaN(slaHours) || String(slaHours).trim() === "") return;
    if (!declineReason || declineReason.trim() === "") return;

    try {
      // 1️⃣ Update tableData locally
      setTableData((prevData) => {
        const updated = [...prevData];
        updated[declineTaskIndex] = { ...declineTask, declined: true };
        return updated;
      });

      const trackingclientid = trackingClientId;
      const usersla = slaHours ? `${slaHours} hrs` : "";

      // Determine expectedDeadline (raw)
      let expecteddeadline = "";
      const dateFields = [
        declineTask.expectedDeadline,
        declineTask.etaDate,
        declineTask.deadline,
      ];
      const validDate = dateFields.find(
        (d) => d && moment(d).isValid() && d !== "Invalid date",
      );
      if (validDate) expecteddeadline = validDate;

      // Determine actualDeadline (raw)
      let actualDeadlineRaw = "";
      if (slaHours && !isNaN(slaHours)) {
        actualDeadlineRaw = moment()
          .add(Number(slaHours), "hours")
          .toISOString();
      }

      // Get SLA from task if exists
      const sla = declineTask.eta || declineTask.timeline || "";

      // Use declineReason state
      const reason = declineReason.trim();

      // Prepare payload
      const payload = {
        trackingclientid,
        action: "declined",
        trackingid: declineTask.trackingid,
        sla,
        expecteddeadline,
        usersla,
        actualDeadline: actualDeadlineRaw,
        reason,
      };

      // Send API request
      await api.post(`/taskapproval`, payload, {
        headers: {
          authorizationtoken: ` ${localStorage.getItem("authToken")}`,
        },
      });

      // Show temporary approval message
      if (props.setApprovalMsg) {
        props.setApprovalMsg("Task declined and moved for Approvals");
        setTimeout(() => props.setApprovalMsg(""), 2000);
      }
    } catch (error) {
      console.error("Error declining task:", error);
    } finally {
      // Close modal and reset
      setShowDeclineModal(false);
      setDeclineTask(null);
      setDeclineTaskIndex(null);
      setSlaHours("");
      setActualDeadline("");
      setDeclineReason("");
    }
  };

  const {
    data = [],
    setHistory,
    setShowEditTask,
    setTaskview,
    setTrackingItemData,
    setProjectTable,
    selected_menu,
    setDeleteConfirmationShow,
    fetchAllTracking,
    deletePermission,
    addColumns,
    setAllCheckTable,
    allcheckTable,
    handleMoveCheckboxTable,
  } = props;

  const trackingClientId = useSelector(
    (state) => state.Auth.user.trackingclientid,
  );
  const trackingProjectId = useSelector(
    (state) => state.Auth.user.trackingprojectid,
  );
  let allTrackingsList = useSelector((state) => state.Tracking.allTrackings);
  let myTrackingList = useSelector((state) => state.Tracking.myTrackings);

  const { data: allProjectMembers } = useFetch(
    key.get_all_members,
    `/trackingusers/memberlist/${trackingClientId}`,
    () => {},
    () => {},
    false,
    false,
  );
  let allMembers = allProjectMembers?.data ?? [];

  const { data: allTableHeaders } = useFetch(
    key.get_table_headers,
    `/masterdata/3`,
    () => {},
    () => {},
    false,
    false,
  );

  // Fetch approvals list
  const { data: taskApprovalsData } = useFetch(
    key.get_task_approvals,
    `/taskapproval/${trackingClientId}`,
    () => {},
    () => {},
    false,
    false,
  );

  const { data: allProjectsRes, refetch: getAllProjects } = useFetch(
    key.get_all_projects,
    `/trackingprojects/${trackingClientId}`,
    () => {},
    () => {},
    false,
    false,
  );
  let allProjects = allProjectsRes?.data?.Items ?? [];

  let matchedprojectvalues = allProjects.filter((i, index) => {
    return i?.trackingprojectid === selectedTask?.trackingprojectsid;
  });

  const fetchPriorities = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await api.get(`/tracking/priority/${trackingClientId}`);
      const allProjectsMap = Object.fromEntries(
        allProjects.map((p) => [p.value, p.label]),
      );
      const mappedItems = (res?.data?.data || []).flatMap((item) => {
        const projectName =
          allProjectsMap[item.trackingprojectid] || item.trackingprojectid;
        const trackingprojectid = item.trackingprojectid;
        return (item.prioritydata || []).map((priority) => ({
          ...priority,
          projects: projectName,
          trackingprojectid,
        }));
      });
      dispatch(setAllPriorityData(mappedItems));
    } catch (err) {
      // setError('Failed to fetch priorities');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPriorities();
  }, []);
  console.log("fetchPrioritiesfetchPriorities", fetchPriorities);
  console.log("priorityListpriorityList", priorityList);

  function computeEtaAndDeadlineFromPriority(
    priorityKey,
    project,
    matchedProject,
  ) {
    matchedProject = matchedprojectvalues[0];

    const priorityHoursMap = priorityList.reduce((acc, item) => {
      acc[item.priority] = item.hours;
      return acc;
    }, {});
    console.log("priorityHoursMappriorityHoursMap", priorityHoursMap);
    // = {
    //   "Blocker Level 1": 4,
    //   "Blocker Level 2": 8,
    //   Major: 16,
    //   Medium: 40,
    //   Low: 80,
    // };

    const totalHours = priorityHoursMap[selectedTask?.priority] || 0;
    const workStartHour = `${matchedProject?.starttime}:00`;
    const workEndHour = `${matchedProject?.endtime}:00`;
    const now = new Date();

    // ✅ Step 1: Validate start & end time
    const hasValidShift =
      typeof workStartHour === "string" &&
      workStartHour.trim() !== "" &&
      typeof workEndHour === "string" &&
      workEndHour.trim() !== "";
    let eta;
    console.log("CalculatedETAshift:", eta);

    if (hasValidShift) {
      console.log("CalculatinghasValidShifthours", hasValidShift);
      // ✅ Use shift-based calculation
      // eta = addWorkHoursConsideringShift(
      //   now,
      //   totalHours,
      //   workStartHour,
      //   workEndHour,
      // );
      eta = addWorkHoursConsideringShift(
        now,
        totalHours,
        workStartHour,
        workEndHour,
      );
      console.log("CalculatedETAshift:", eta);
    } else {
      // ⚠️ Fallback: Just add straight hours to current time
      console.warn(
        "⚠️ Missing or empty start/end time, using default ETA calculation",
      );
      eta = new Date(now?.getTime() + totalHours * 60 * 60 * 1000);
    }

    // ✅ Validate that eta is a valid Date
    const safeEta = eta instanceof Date && !isNaN(eta) ? eta : new Date();

    return {
      startTime: now?.toISOString(),
      estimatedEndTime: safeEta?.toISOString(),
      totalHours: totalHours,
    };
  }

  // function addWorkHoursConsideringShift(
  //   startTime,
  //   workHours,
  //   shiftStartStr,
  //   shiftEndStr,
  // ) {
  //   const safeShiftStart =
  //     typeof shiftStartStr === "string" && shiftStartStr?.trim() !== ""
  //       ? shiftStartStr
  //       : "09:00:00";
  //   const safeShiftEnd =
  //     typeof shiftEndStr === "string" && shiftEndStr?.trim() !== ""
  //       ? shiftEndStr
  //       : "17:00:00";

  //   const [sH, sM, sS] = safeShiftStart.replace("Z", "").split(":").map(Number);
  //   const [eH, eM, eS] = safeShiftEnd.replace("Z", "").split(":").map(Number);

  //   if ([sH, eH].some(isNaN)) {
  //     console.warn("⚠️ Invalid shift hours, using default 9AM–5PM");
  //     return new Date(startTime.getTime() + workHours * 60 * 60 * 1000);
  //   }

  //   const result = new Date(startTime);
  //   let remainingHours = workHours;

  //   while (remainingHours > 0) {
  //     const shiftStart = new Date(result);
  //     shiftStart?.setHours(sH, sM, sS, 0);
  //     const shiftEnd = new Date(result);
  //     shiftEnd?.setHours(eH, eM, eS, 0);
  //     if (shiftEnd <= shiftStart) shiftEnd.setDate(shiftEnd?.getDate() + 1);

  //     const day = shiftStart.getDay();
  //     // console.log("holidays-->", holidays);
  //     if (
  //       day === 6 ||
  //       day === 0
  //       // holidays?.includes(moment(shiftStart).format("DD-MM-YYYY"))
  //     ) {
  //       const daysToAdd = day === 6 ? 2 : 1;
  //       shiftStart.setDate(shiftStart?.getDate() + daysToAdd);
  //       shiftEnd.setDate(shiftEnd?.getDate() + daysToAdd);
  //       result.setTime(shiftStart?.getTime());
  //       continue;
  //     }

  //     if (result < shiftStart) result?.setTime(shiftStart?.getTime());
  //     if (result >= shiftEnd) {
  //       shiftStart.setDate(shiftStart?.getDate() + 1);
  //       result.setTime(shiftStart?.getTime());
  //       continue;
  //     }

  //     const availableHoursToday = (shiftEnd - result) / (1000 * 60 * 60);
  //     const hoursToAdd = Math.min(availableHoursToday, remainingHours);
  //     result?.setTime(result.getTime() + hoursToAdd * 60 * 60 * 1000);
  //     remainingHours -= hoursToAdd;
  //     if (remainingHours > 0) {
  //       shiftStart?.setDate(shiftStart?.getDate() + 1);
  //       result?.setTime(shiftStart?.getTime());
  //     }
  //   }

  //   return result;
  // }

  function parse12HourTo24(timeStr) {
    if (!timeStr || typeof timeStr !== "string") return null;

    const cleaned = timeStr.trim();

    // Detect AM/PM format: e.g. "08:00 AM", "6:00PM", "08:00:00 AM"
    const ampmMatch = cleaned.match(
      /^(\d{1,2}):(\d{2})(?::(\d{2}))?\s*(AM|PM)$/i,
    );
    if (ampmMatch) {
      let h = parseInt(ampmMatch[1], 10);
      const m = parseInt(ampmMatch[2], 10);
      const s = ampmMatch[3] ? parseInt(ampmMatch[3], 10) : 0;
      const period = ampmMatch[4].toUpperCase();

      if (period === "AM") {
        if (h === 12) h = 0; // 12:00 AM → 00:00
      } else {
        if (h !== 12) h += 12; // e.g. 6 PM → 18, but 12 PM stays 12
      }
      return { h, m, s };
    }

    // Fallback: plain 24-hour string "08:00" or "08:00:00"
    const plainMatch = cleaned
      .replace("Z", "")
      .match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?$/);
    if (plainMatch) {
      return {
        h: parseInt(plainMatch[1], 10),
        m: parseInt(plainMatch[2], 10),
        s: plainMatch[3] ? parseInt(plainMatch[3], 10) : 0,
      };
    }

    return null;
  }

  function addWorkHoursConsideringShift(
    startTime,
    workHours,
    shiftStartStr,
    shiftEndStr,
  ) {
    console.log("🚀 FUNCTION START");
    console.log(
      "Starthdhsjhdjs",
      startTime,
      "Starthdhsjhdjs",
      workHours,
      "Starthdhsjhdjs",
      shiftStartStr,
      "Starthdhsjhdjs",
      shiftEndStr,
    );

    const startParsed = parse12HourTo24(shiftStartStr) || { h: 9, m: 0, s: 0 };
    const endParsed = parse12HourTo24(shiftEndStr) || { h: 17, m: 0, s: 0 };

    const { h: sH, m: sM, s: sS } = startParsed;
    const { h: eH, m: eM, s: eS } = endParsed;

    console.log(`🕒 Parsed Shift: ${sH}:${sM}:${sS} → ${eH}:${eM}:${eS}`);

    if (isNaN(sH) || isNaN(eH)) {
      console.warn("⚠️ Invalid shift hours, fallback applied");
      const fallback = new Date(
        startTime.getTime() + workHours * 60 * 60 * 1000,
      );
      console.log("Fallback Result:", fallback);
      return fallback;
    }

    const result = new Date(startTime);
    let remainingHours = workHours;

    console.log("📍 Initial Result:", result);

    while (remainingHours > 0) {
      console.log("🔁 LOOP START");
      console.log("Current Result Time:", result);
      console.log("Remaining Hours:", remainingHours);

      const shiftStart = new Date(result);
      shiftStart.setHours(sH, sM, sS, 0);

      const shiftEnd = new Date(result);
      shiftEnd.setHours(eH, eM, eS, 0);

      if (shiftEnd <= shiftStart) {
        shiftEnd.setDate(shiftEnd.getDate() + 1);
        console.log(
          "🌙 Overnight shift detected, adjusted shiftEnd:",
          shiftEnd,
        );
      }

      console.log(shiftStart, "ShiftStartTime:", shiftEnd);
      console.log("Shift End Time:", shiftEnd);

      const day = result.getDay();
      console.log("📅 Day of week:", day);

      if (day === 6 || day === 0) {
        const daysToAdd = day === 6 ? 2 : 1;
        console.log("⛔ Weekend detected, skipping days:", daysToAdd);

        result.setDate(result.getDate() + daysToAdd);
        result.setHours(sH, sM, sS, 0);

        console.log("➡️ Moved to next working day:", result);
        continue;
      }

      if (result < shiftStart) {
        console.log("⏩ Before shift start, jumping to shift start");
        result.setTime(shiftStart.getTime());
      }

      if (result >= shiftEnd) {
        console.log("⏭️ After shift end, moving to next day");

        result.setDate(result.getDate() + 1);
        result.setHours(sH, sM, sS, 0);

        console.log("➡️ Next day start:", result);
        continue;
      }

      const availableHoursToday = (shiftEnd - result) / (1000 * 60 * 60);
      console.log("⏳ Available Hours Today:", availableHoursToday);

      const hoursToAdd = Math.min(availableHoursToday, remainingHours);
      console.log("➕ Hours to Add Now:", hoursToAdd);

      result.setTime(result.getTime() + hoursToAdd * 60 * 60 * 1000);
      remainingHours -= hoursToAdd;

      console.log("🆕 Updated Result:", result);
      console.log("📉 Remaining Hours After Deduction:", remainingHours);

      if (remainingHours > 0) {
        console.log("➡️ Moving to next working day");

        result.setDate(result.getDate() + 1);
        result.setHours(sH, sM, sS, 0);

        console.log("📍 Next Day Start:", result);
      }
    }

    console.log("🏁 FINAL ETA:", result);
    console.log("✅ FUNCTION END");

    return result;
  }

  const approvalsMap = React.useMemo(() => {
    const map = {};
    if (taskApprovalsData?.data?.length) {
      taskApprovalsData.data.forEach((ap) => {
        map[ap.trackingid] = ap.action; // e.g., 'accepted' or 'declined'
      });
    }
    return map;
  }, [taskApprovalsData]);

  let allTaskHeadersNames = allTableHeaders?.data ?? [];

  const largeScreen = useMediaQuery("(min-width:991px)");

  const resetState = () => {
    setHistory("");
    setShowEditTask({
      editTitle: false,
      editProject: false,
      editTaskType: false,
      editReportedBy: false,
      editAssignedTo: false,
      editPriority: false,
      editTimeline: false,
      editStatus: false,
      editDescription: false,
      editfileurls: false,
    });
  };
  const [tableData, setTableData] = useState(data);

  useEffect(() => {
    setTableData(data);
  }, [data]);

  const handleDragEnd = (e) => {
    if (!e.destination) return;
    let tempData = Array.from(tableData);
    let [source_data] = tempData.splice(e.source.index, 1);
    tempData.splice(e.destination.index, 0, source_data);
    setTableData(tempData);
  };

  const checkIconStyle = {
    color: "#4EB6EE",
    fontSize: "14px",
    marginTop: "-2%",
    paddingRight: "2px",
  };
  const copytextStyle = {
    color: "#4EB6EE",
    fontSize: "10px",
    padding: "3px",
  };

  let columnValues = {};

  for (let i = 0; i < allTaskHeadersNames.length; i++) {
    columnValues.column1 = allTaskHeadersNames[i].column1;
    columnValues.column2 = allTaskHeadersNames[i].column2;
    columnValues.column3 = allTaskHeadersNames[i].column3;
    columnValues.column4 = allTaskHeadersNames[i].column4;
    columnValues.column5 = allTaskHeadersNames[i].column5;
    columnValues.column6 = allTaskHeadersNames[i].column6;
    columnValues.column7 = allTaskHeadersNames[i].column7;
    columnValues.column8 = allTaskHeadersNames[i].column8;
    columnValues.column9 = allTaskHeadersNames[i].column9;
    columnValues.column10 = allTaskHeadersNames[i].column10;
  }
  useEffect(() => {}, [tableData]);

  const DropableTable = () => {
    return (
      <Droppable droppableId="droppable-1">
        {(provider) => (
          <tbody ref={provider.innerRef} {...provider.droppableProps}>
            {tableData.map((item, i) => {
              const handleCopyIcon = (e) => {};

              const copyTicketNumber = (e) => {
                var text = trackingClientId + "-" + item.trackingid;
                Copy(text);
              };
              return (
                <Draggable
                  key={item.trackingid}
                  draggableId={item.trackingid.toString()}
                  index={i}
                >
                  {(provider) => (
                    <tr
                      className="all_table_row"
                      val={item}
                      {...provider.draggableProps}
                      ref={provider.innerRef}
                      onClick={(e) => {
                        setTaskview("taskview");
                        setTrackingItemData(
                          (selected_menu === "all_tasks"
                            ? allTrackingsList
                            : myTrackingList
                          ).find(
                            (element) => element.trackingid === item.trackingid,
                          ),
                        );
                        resetState();
                      }}
                    >
                      {largeScreen && (
                        <>
                          <td
                            {...provider.dragHandleProps}
                            className="drag-indicator"
                          >
                            <div className="d-flex justify-content-between align-items-center gap-2">
                              <div className="drag-icon">
                                <DragIndicatorIcon />
                              </div>
                              <input
                                type="checkbox"
                                name="group1"
                                className="table_check_box"
                                onChange={() =>
                                  handleMoveCheckboxTable(item, i)
                                } // Wrap the function call inside an arrow function
                                checked={allcheckTable?.some(
                                  (row) => row.index === i,
                                )}
                                onClick={(e) => e.stopPropagation()}
                              />
                            </div>
                          </td>
                        </>
                      )}
                      <td className="text-nowrap">
                        <strong className="mobHead">Task No. : </strong>
                        <span className="tracking-id">
                          {trackingClientId}-{item.trackingid}
                          {item.priority === "blocker" ||
                          item.priority === "blocker2" ? (
                            <BlockIcon
                              className="block-icon"
                              style={{
                                cursor: "pointer",
                                color: "red",
                                fontSize: "17px",
                                margin: "0px 0px 3px 0px",
                              }}
                            />
                          ) : (
                            <></>
                          )}
                        </span>
                        <div
                          style={{
                            width: 20,
                            height: 20,
                            display: "inline-block",
                            padding: "6px 0px 3px 3px",
                            cursor: "pointer",
                          }}
                          id={`showicon-index-${i}`}
                          onMouseEnter={handleCopyIcon}
                          onMouseLeave={(e) => {}}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <OverlayTrigger
                            trigger="click"
                            rootClose="false"
                            placement="top"
                            overlay={
                              <Popover style={copytextStyle}>
                                <CheckCircleIcon style={checkIconStyle} />
                                Copied
                              </Popover>
                            }
                          >
                            <img
                              src={CopyIcon}
                              height={15}
                              width={15}
                              alt="copyIcon"
                              style={{ display: "block" }}
                              onClick={copyTicketNumber}
                            />
                          </OverlayTrigger>
                        </div>
                      </td>
                      <td
                        className="text-nowrap text-truncate"
                        style={{ maxWidth: "150px" }}
                      >
                        <strong className="mobHead">Project Name : </strong>
                        <span>{item.project_name}</span>
                      </td>
                      <td
                        className="text-nowrap text-truncate"
                        style={{ maxWidth: "200px" }}
                      >
                        <strong className="mobHead">Title : </strong>
                        <span>{item.title}</span>
                      </td>

                      <td
                        className="text-capitalize text-nowrap"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        <strong className="mobHead">Status : </strong>
                        <span>{item.status_name}</span>
                      </td>
                      {/* 
                      <td className='text-capitalize'>
                        <strong className='mobHead'>Timeline : </strong>
                        {item.timeline !== "" ? (
                          <span>{item.timeline} hr</span>
                        ) : (
                          <span className='timeline_isempty'>-</span>
                        )}
                      </td>
                     */}
                      <td className="text-nowrap">
                        <strong className="mobHead">Priority : </strong>
                        <span className="text-capitalize">
                          {item.priority !== ""
                            ? item.priority === "blocker" ||
                              item.priority === "blocker1"
                              ? "Blocker Level 1"
                              : item.priority === "blocker2"
                                ? "Blocker Level 2"
                                : item.priority === ""
                                  ? "-"
                                  : item.priority
                            : "-"}
                        </span>
                      </td>

                      <td
                        className="text-nowrap"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        <strong className="mobHead">Expected SLA : </strong>
                        <span>
                          {item.eta === "" || item.eta == null
                            ? "-"
                            : `${item.eta
                                .toString()
                                .replace(/hrs?/i, "")
                                .trim()} hrs`}
                        </span>
                      </td>
                      <td
                        className="text-nowrap"
                        style={{ whiteSpace: "nowrap", maxWidth: "180px" }}
                      >
                        <strong className="mobHead">
                          Expected Deadline :{" "}
                        </strong>
                        <span>
                          {!item.deadline
                            ? "-"
                            : moment(item.deadline, [
                                "DD/MM/YYYY, HH:mm",
                                "DD/MM/YYYY, hh:mm A",
                                "DD/MM/YYYY, hh:mm a",
                                "DD-MM-YYYY HH:mm",
                                moment.ISO_8601,
                              ]).format("MMM D, YYYY hh:mm A")}
                        </span>
                      </td>
                      <td className="text-center">
                        <strong className="mobHead">Deadline signal : </strong>
                        <span
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "6px",
                          }}
                        >
                          {/* {(() => {
                            const deadline = moment(item.deadline);
                            const originalDeadline = moment(
                              item.originaldeadline,
                            );
                            const now = moment();
                            const status = item.status_name?.[0];
                            let color = "";
                            let text = "";

                            // Task not closed
                            if (status !== "Closed") {
                              if (deadline.isBefore(now)) {
                                color = "red"; // ❌ missed deadline
                                text = "RED";
                              } else {
                                color = "yellow"; // ⏳ still within deadline
                                text = "YELLOW";
                              }
                            }

                            // Task closed
                            if (status === "Closed") {
                              if (deadline.isSameOrBefore(originalDeadline)) {
                                // ✅ closed before or exactly on original deadline
                                color = "green";
                                text = "GREEN";
                              } else {
                                // ❌ closed after original deadline
                                color = "red";
                                text = "RED";
                              }
                            }

                            if (!color) return null;

                            const imgSrc =
                              color === "green"
                                ? greenIcon
                                : color === "yellow"
                                  ? yellowIcon
                                  : redIcon;

                            return (
                              <span
                                style={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                  gap: "4px",
                                }}
                              >
                                <img
                                  src={imgSrc}
                                  alt={text}
                                  style={{ width: "16px", height: "16px" }}
                                />
                                <span>{text}</span>
                              </span>
                            );
                          })()} */}

                          {(() => {
                            const hasDeadline =
                              item.deadline !== undefined &&
                              item.deadline !== null &&
                              item.deadline !== "";
                            const deadline = hasDeadline
                              ? moment(item.deadline, [
                                  "DD-MM-YYYY HH:mm",
                                  "DD/MM/YYYY, HH:mm",
                                  "DD/MM/YYYY, hh:mm A",
                                  "DD/MM/YYYY, hh:mm a",
                                  moment.ISO_8601,
                                ])
                              : null;
                            const closedTime = item.ClosedTime
                              ? moment(item.ClosedTime)
                              : null;
                            const now = moment();
                            const status = item.status_name?.[0]
                              ?.trim()
                              .toLowerCase();

                            let color = "";
                            let text = "";

                            // No usable deadline → no signal to compute
                            if (!deadline || !deadline.isValid()) {
                              color = "";
                              text = "";
                            }

                            // ================= CLOSED TASK LOGIC =================
                            else if (closedTime && closedTime.isValid()) {
                              // 🔴 Late
                              if (closedTime.isAfter(deadline)) {
                                color = "red";
                                text = "RED";
                              }
                              // 🟢 Exact time
                              else if (closedTime.isSame(deadline)) {
                                color = "green";
                                text = "GREEN";
                              }
                              // Closed before deadline
                              else {
                                if (
                                  status === "closed" ||
                                  status === "completed"
                                ) {
                                  color = "green";
                                  text = "GREEN";
                                } else {
                                  color = "yellow";
                                  text = "YELLOW";
                                }
                              }
                            }

                            // ================= NOT CLOSED YET =================
                            else {
                              // Deadline passed but not closed → 🔴 SLA BREACH
                              if (now.isAfter(deadline)) {
                                color = "red";
                                text = "RED";
                              }
                              // Still before deadline → 🟡 In progress
                              else {
                                color = "yellow";
                                text = "YELLOW";
                              }
                            }

                            return (
                              <span
                                style={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                  gap: "8px",
                                }}
                              >
                                {color ? (
                                  <>
                                    <span
                                      className={`deadline-signal-dot is-${color}`}
                                    />
                                    <span>{text}</span>
                                  </>
                                ) : (
                                  "-"
                                )}
                              </span>
                            );
                          })()}
                        </span>
                      </td>

                      <td
                        style={{ width: "300", whiteSpace: "nowrap" }}
                        className="text-center text-nowrap"
                      >
                        {console.log(
                          "approvalsMapitemtrackingid",
                          selected_menu,
                        )}
                        {selected_menu === "my_tasks" &&
                          item?.approvalaction !== "accepted" && (
                            // Only show if istaskapproval is true or "yes"
                            <>
                              <Button
                                size="sm"
                                variant="link"
                                className="text-decoration-none pe-1 ps-1"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleAcceptTask(item, i);
                                }}
                              >
                                <CheckCircleIcon
                                  style={{ color: "green", fontSize: 20 }}
                                />
                              </Button>
                              <Button
                                size="sm"
                                variant="link"
                                className="text-decoration-none pe-1 ps-1"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleDeclineTask(item, i);
                                }}
                                title="Decline Task"
                              >
                                <BlockIcon
                                  style={{ color: "red", fontSize: 20 }}
                                />
                              </Button>
                            </>
                          )}
                        {/* Existing delete button logic */}
                        {deletePermission && (
                          <Button
                            size="sm"
                            variant="link"
                            className="text-decoration-none pe-1 ps-1"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <img
                              alt="img"
                              src={trashIcon}
                              onClick={(e) => {
                                setDeleteConfirmationShow(true);
                                setTrackingItemData(item);
                              }}
                            />
                          </Button>
                        )}
                      </td>
                    </tr>
                  )}
                </Draggable>
              );
            })}
            {provider.placeholder}
          </tbody>
        )}
      </Droppable>
    );
  };

  // Decline Task Modal JSX
  const isDeclineDisabled =
    !slaHours ||
    isNaN(slaHours) ||
    String(slaHours).trim() === "" ||
    !declineReason ||
    declineReason.trim() === "";
  const declineTaskModal = (
    <Modal
      show={showDeclineModal}
      onHide={() => {
        setShowDeclineModal(false);
        setSlaHours("");
        setActualDeadline("");
        setDeclineReason("");
      }}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Decline Task</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {declineTask ? (
          <div>
            {/* Existing SLA + Expected Deadline Row */}
            <Row className="g-0 mb-3">
              <Col className="text-white d-flex align-items-center">
                <strong>SLA :</strong>&nbsp;
                {declineTask.sla ||
                  declineTask.eta ||
                  declineTask.timeline ||
                  "-"}
              </Col>
              <Col className="text-white d-flex align-items-center">
                <strong>Expected Deadline:</strong>&nbsp;
                {(() => {
                  const dateFields = [
                    declineTask.expectedDeadline,
                    declineTask.etaDate,
                    declineTask.deadline,
                  ];
                  const validDate = dateFields.find((d) => {
                    if (!d || d === "Invalid date") return false;
                    const parsed = moment(d, [
                      "DD/MM/YYYY, HH:mm",
                      "DD/MM/YYYY, hh:mm A",
                      "DD/MM/YYYY, hh:mm a",
                      moment.ISO_8601,
                    ]);
                    return parsed.isValid();
                  });

                  if (!validDate) return "-";

                  const parsed = moment(validDate, [
                    "DD/MM/YYYY, HH:mm",
                    "DD/MM/YYYY, hh:mm A",
                    "DD/MM/YYYY, hh:mm a",
                    moment.ISO_8601,
                  ]);

                  return parsed.isValid()
                    ? parsed.format("MMM D, YYYY hh:mm A")
                    : "-";
                })()}
              </Col>
            </Row>

            {/* Input fields */}
            <Row className="mb-3">
              <Col>
                <label className="form-label text-white">
                  Your SLA (in hours)
                </label>
                <input
                  type="text" // use text to fully control input
                  className="form-control"
                  value={slaHours}
                  onChange={handleSlaChange}
                  inputMode="numeric" // mobile numeric keypad
                  pattern="[0-9]*" // HTML validation
                />
              </Col>

              <Col>
                <label className="form-label text-white">Actual Deadline</label>
                <input
                  type="text"
                  className="form-control"
                  value={actualDeadline}
                  readOnly
                />
              </Col>
            </Row>

            {/* Reason textarea */}
            <Row>
              <Col>
                <label className="form-label text-white">Reason</label>
                <textarea
                  id="decline-reason-textarea"
                  className="form-control"
                  rows="3"
                  placeholder="At least 3 lines"
                  style={{ color: "white" }}
                  value={declineReason}
                  onChange={(e) => setDeclineReason(e.target.value)}
                ></textarea>
              </Col>
            </Row>
          </div>
        ) : (
          <p>Loading...</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          className="deletebtn mx-3 my-2"
          style={{ background: "#4EB6EE" }}
          onClick={() => {
            setShowDeclineModal(false);
            setSlaHours("");
            setActualDeadline("");
            setDeclineReason("");
          }}
        >
          Cancel
        </Button>
        <Button
          className="deletebtn mx-3 my-2"
          style={{ background: "#4EB6EE" }}
          variant="danger"
          onClick={confirmDeclineTask}
          disabled={isDeclineDisabled}
        >
          Decline Task
        </Button>
      </Modal.Footer>
    </Modal>
  );

  // Accept Task Modal JSX
  const acceptTaskModal = (
    <Modal
      show={showAcceptModal}
      onHide={() => setShowAcceptModal(false)}
      centered
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        {selectedTask ? (
          <p>
            Are you sure you want to accept task{" "}
            <strong>{selectedTask.title}</strong>
            (ID: {trackingClientId}-{selectedTask.trackingid})?
          </p>
        ) : (
          <p>Loading...</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          className="deletebtn mx-3 my-2"
          style={{ background: "#4EB6EE" }}
          onClick={() => setShowAcceptModal(false)}
        >
          Cancel
        </Button>
        <Button
          className="deletebtn mx-3 my-2"
          style={{ background: "#4EB6EE" }}
          variant="success"
          onClick={async () => {
            setShowAcceptModal(false);
            // Mark the task as accepted in tableData
            if (acceptTaskIndex !== null) {
              setTableData((prev) => {
                const updated = [...prev];
                if (updated[acceptTaskIndex]) {
                  updated[acceptTaskIndex] = {
                    ...updated[acceptTaskIndex],
                    accepted: true,
                  };
                }
                return updated;
              });
            }

            // Call POST /taskapproval API to mark as accepted
            if (selectedTask) {
              // Step 1: Calculate actualTimeline by adding SLA to current time
              let actualTimeline = null;
              if (selectedTask.eta || selectedTask.timeline) {
                const sla = (selectedTask.eta || selectedTask.timeline) + "";
                const slaMatch = sla.match(
                  /(\d+)\s*(hr|hrs|hour|hours|day|days)/i,
                );

                if (slaMatch) {
                  const value = parseInt(slaMatch[1], 10);
                  const unit = slaMatch[2].toLowerCase();
                  let momentUnit = "hours";
                  if (unit.includes("day")) momentUnit = "days";
                  actualTimeline = moment()
                    .utcOffset("+05:30")
                    .add(value, momentUnit)
                    .toISOString();
                } else {
                  actualTimeline = moment().utcOffset("+05:30").toISOString();
                }
              } else {
                actualTimeline = moment().utcOffset("+05:30").toISOString();
              }

              // Step 2: Calculate actualDeadline by adding SLA
              let actualDeadline = null;
              if (selectedTask.eta || selectedTask.timeline) {
                const sla = (selectedTask.eta || selectedTask.timeline) + ""; // e.g., "8 hrs"
                const slaMatch = sla.match(
                  /(\d+)\s*(hr|hrs|hour|hours|day|days)/i,
                );
                if (slaMatch) {
                  const value = parseInt(slaMatch[1], 10);
                  const unit = slaMatch[2].toLowerCase();
                  let momentUnit = "hours";
                  if (unit.includes("day")) momentUnit = "days";
                  actualDeadline = moment()
                    .utcOffset("+05:30")
                    .add(value, momentUnit)
                    .format("DD/MM/YYYY, hh:mm A");
                }
              }
              let calculatedvalues = computeEtaAndDeadlineFromPriority(
                selectedTask?.priority,
                null,
                matchedprojectvalues,
              );
              console.log("calculatedvaluescalculatedvalues", calculatedvalues);

              // Step 3: Prepare payload
              const payload = {
                action: "accepted",
                actualTimeline:
                  selectedTask?.deadlineType === "No"
                    ? calculatedvalues?.estimatedEndTime
                    : selectedTask?.deadline,
              };
              console.log("payloadacceptance", payload);

              const payloadGet = {
                assignedto: [],
                fromdate: "",
                priority: [],
                reportedby: [],
                status: [],
                tasktype: [],
                todate: "",
                trackingprojectsid: [],
                userAccessibleProjects: [],
              };

              const resource1 = trackingClientId;
              const resource2 = selectedTask.trackingid;

              try {
                let response = await api.patch(
                  `/taskapproval/${resource1}/${resource2}`,
                  payload,
                  {
                    headers: {
                      authorizationtoken: `${localStorage.getItem(
                        "authToken",
                      )}`,
                    },
                  },
                );

                if (response.status === 200) {
                  const filterResp = await api.post(
                    "/tracking/taskfilter",
                    {
                      assignedto: [user.trackinguserid],
                      fromdate: "",
                      priority: [],
                      reportedby: [],
                      status: [],
                      tasktype: [],
                      todate: "",
                      trackingprojectsid: [],
                      userAccessibleProjects: [],
                      // trackingclientId: trackingClientId,
                    },
                    {
                      headers: {
                        authorizationtoken: ` ${authToken}`,
                      },
                    },
                  );
                  // Update the expected deadline in the table row if available
                  if (
                    filterResp &&
                    filterResp.data &&
                    Array.isArray(filterResp.data.data)
                  ) {
                    // Find the updated task in the response
                    const updatedTask = filterResp.data.data.find(
                      (t) => t.trackingid === selectedTask.trackingid,
                    );
                    if (updatedTask && updatedTask.deadline) {
                      setTableData((prev) => {
                        const updated = [...prev];
                        if (updated[acceptTaskIndex]) {
                          updated[acceptTaskIndex] = {
                            ...updated[acceptTaskIndex],
                            deadline: updatedTask.deadline,
                            approvalaction:
                              updatedTask.approvalaction ??
                              updated[acceptTaskIndex].approvalaction,
                          };
                        }
                        return updated;
                      });
                    }
                    dispatch(setMyTrackings(filterResp.data.data));
                  }
                }
              } catch (error) {
                console.error("Task approval error:", error);
              }
            }

            if (props.setApprovalMsg) {
              props.setApprovalMsg("Task accepted and ready to start");
              setTimeout(() => props.setApprovalMsg(""), 2000);
            }
          }}
        >
          Accept
        </Button>
      </Modal.Footer>
    </Modal>
  );

  return setProjectTable ? (
    !props.loading ? (
      <Card className="border-0 mb-3 table-view-card">
        <Card.Body>
          <Row>
            <Col sm={12} className="mb-2">
              {props.header}
            </Col>
            {props.extra ? (
              <Col sm={12} className="mb-2">
                {props.extra}
              </Col>
            ) : (
              <></>
            )}

            <Col md={12}>
              {props.data?.length > 0 ? (
                <TableWrap>
                  <InfiniteScroll
                    refreshFunction={props.fetchAllTracking}
                    dataLength={props.data.length}
                    next={props.fetchAllTracking}
                    hasMore={
                      props.isFilterActive
                        ? props.data.length > 7
                        : props.startTrackingId !== "none" &&
                          props.data.length > 7
                    }
                    loader={
                      <div className="text-center mt-5 mb-5">
                        {props.isFilterActive && filterDataLoading ? (
                          <>
                            {/* <Spinner animation="border" variant="info" /> */}
                          </>
                        ) : props?.isFilterActive ? (
                          <></>
                        ) : (
                          <>
                            {/* <Spinner animation="border" variant="info" /> */}
                          </>
                        )}
                      </div>
                    }
                  >
                    {console.log(props?.isloaderreopen, "loadsjdsjjs")}

                    <Table
                      className="mb-0"
                      striped
                      responsive
                      bordered
                      hover
                      size="sm md lg xl xxl"
                    >
                      <thead>
                        <tr>{props.columns}</tr>
                      </thead>
                      {console.log(props?.trackingLoading, "hjdshjshj")}
                      {/* {props?.trackingLoading ? (
                        <Spinner animation="border" variant="info" />
                      ) : (
                        <tbody>{props.data}</tbody>
                      )} */}
                      <tbody>
                        {console.log(
                          props?.tabletrackingLoading,
                          "propsloader",
                          props?.tableloader,
                        )}
                        {props?.tableloader ||
                        props?.tabletrackingLoading ||
                        props?.trackingLoading ||
                        props?.isloading ||
                        props?.isloaderreopen ? (
                          <tr>
                            <td colSpan={100}>
                              <div
                                className="d-flex justify-content-center align-items-center"
                                style={{ height: "120px" }}
                              >
                                <Spinner animation="border" variant="info" />
                              </div>
                            </td>
                          </tr>
                        ) : (
                          props.data
                        )}
                      </tbody>
                    </Table>
                  </InfiniteScroll>
                </TableWrap>
              ) : (
                <>
                  {console.log(props?.isloaderreopen, "propsloadernotfound")}
                  {props?.isloaderreopen ? (
                    <TableWrap>
                      <div className="spinner_container">
                        <Spinner animation="border" variant="info" />
                      </div>
                    </TableWrap>
                  ) : (
                    props.notfound
                  )}
                </>
              )}
            </Col>
          </Row>
        </Card.Body>
        {acceptTaskModal}
        {declineTaskModal}
      </Card>
    ) : (
      <div className="text-center mt-5 mb-5">
        {/* <Spinner animation="border" variant="info" /> */}
      </div>
    )
  ) : (
    <Card className="border-0 mb-3 table-view-card">
      <Card.Body>
        {!props.loading ? (
          <Row>
            <Col sm={12} className="mb-2">
              {props.header}
            </Col>
            {props.extra ? (
              <Col sm={12} className="mb-2">
                {props.extra}
              </Col>
            ) : (
              <></>
            )}
            <Col md={12}>
              {props.data?.length > 0 ? (
                <TableWrap>
                  {props.showInfiniteScroll ? (
                    <InfiniteScroll
                      dataLength={props.data.length}
                      next={props.fetchAllTracking}
                      hasMore={
                        props.startTrackingId !== "none" &&
                        props.data.length > 0
                          ? false
                          : false
                      }
                      loader={
                        <div className="text-center mt-5 mb-5">
                          <Spinner animation="border" variant="info" />
                        </div>
                      }
                    >
                      <DragDropContext onDragEnd={handleDragEnd}>
                        <Table
                          className="mb-0"
                          striped
                          responsive
                          bordered
                          hover
                          size="sm md lg xl xxl "
                        >
                          <thead>
                            <tr>{props.columns}</tr>
                          </thead>

                          <DropableTable />
                        </Table>
                      </DragDropContext>
                    </InfiniteScroll>
                  ) : (
                    <Table
                      className="mb-0"
                      striped
                      responsive
                      bordered
                      hover
                      size="sm md lg xl xxl "
                    >
                      <thead>
                        <tr>{props.columns}</tr>
                      </thead>

                      <DropableTable />
                    </Table>
                  )}
                </TableWrap>
              ) : (
                <Alert
                  style={{ height: "auto" }}
                  className="text-center mt-2"
                  variant="primary"
                >
                  {props.notfound}
                </Alert>
              )}
            </Col>
          </Row>
        ) : (
          <div className="text-center mt-5 mb-5">
            <Spinner animation="border" variant="info" />
          </div>
        )}
      </Card.Body>
      {acceptTaskModal}
      {declineTaskModal}
    </Card>
  );
};

export default Tables;
